export const shortUUID = () => crypto.randomUUID().split('-').slice(1, 4).join('');
